// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c37c0d82","732":"e3ad56ae","977":"c200ff38"}[chunkId] + ".chunk.js";
};